import { NgModule } from '@angular/core'
import { HUB_URL } from '../variables'

/**
 * Get parent domain name from current domain
 *
 * Example:
 *
 * test.eu.burthub.com' => 'eu.burthub.com'
 */
export function hubUrlFactory() {
  const hostname = window.location.hostname
  const mainDomain = hostname.split('.').slice(1).join('.')

  return mainDomain ? `//${mainDomain}` : hostname
}

@NgModule({
  providers: [{
    provide: HUB_URL,
    useFactory: hubUrlFactory
  }]
})
export class HubUrlModule {}
